import React from "react";

/**
 * Currency input that allows commas and dots as decimal separator.
 * Emits the raw string to the parent (which sends to backend, where money()
 * parses it robustly).
 */
export default function MoneyInput({ value, onChange, className = "input-brutal", placeholder = "0,00", ...props }) {
  const handleChange = (e) => {
    // Allow digits, comma, dot, minus
    const v = e.target.value.replace(/[^\d.,-]/g, "");
    onChange(v);
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={value ?? ""}
      onChange={handleChange}
      className={className}
      placeholder={placeholder}
      {...props}
    />
  );
}

/** Parse "1.234,56" or "1234.56" or "1234,56" into a number for computations. */
export const parseMoney = (v) => {
  if (typeof v === "number") return v;
  const s = String(v ?? "").trim().replace(/R\$\s?/i, "").replace(/\s/g, "");
  if (!s) return 0;
  let n = s;
  if (n.includes(",") && n.includes(".")) n = n.replace(/\./g, "").replace(",", ".");
  else if (n.includes(",")) n = n.replace(",", ".");
  const f = parseFloat(n);
  return Number.isFinite(f) ? f : 0;
};
